import { render, staticRenderFns } from "./SolicitarLigacao.vue?vue&type=template&id=5866a664"
import script from "./SolicitarLigacao.vue?vue&type=script&lang=js"
export * from "./SolicitarLigacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports